import {Button, Modal} from '@yandex-delivery/blocks'
import {Input, InputVariants} from '@yandex-delivery/blocks/legacy'
import React, {useCallback, useState} from 'react'
import i18n from 'src/shared/i18n'

import {classes} from './CommentDesktop.styles'

type Props = {
  comment?: string
  onSubmit: (newComment: string) => void
  onClose: VoidFunction
}

const DetailsDesktop: React.FC<Props> = ({comment = '', onClose, onSubmit}) => {
  const [newComment, setNewComment] = useState<string>(comment)
  const handleCommentChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(event => {
    setNewComment(event.target.value)
  }, [])
  const handleSubmitClick = useCallback(() => onSubmit(newComment), [newComment, onSubmit])

  return (
    <Modal className={classes.modalBody} data-e2e="modal-feedback-delivery" onClose={onClose} opened>
      <Modal.Title variant="title4">{i18n.print('route_feedback')}</Modal.Title>
      <Input
        className={classes.input}
        clearable={false}
        data-e2e="input-feedback-delivery"
        onChange={handleCommentChange}
        placeholder={i18n.print('route_feedback_comment')}
        value={newComment}
        variant={InputVariants.Line}
      />
      <Button className={classes.button} data-e2e="button-save" fullWidth onPress={handleSubmitClick} variant="action">
        {i18n.print('route_feedback_done')}
      </Button>
    </Modal>
  )
}

export default DetailsDesktop
